import React, { memo } from "react";
import GoHome from "../shared/GoHome";

const ErrorPage = () => <GoHome>Error when retrieving data.</GoHome>;

export default memo(ErrorPage);
